(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-reservation"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-cb-reservation]');
    const plan = root?.querySelector('#cb-booking-plan');
    if (!root || !plan) return;

    const extraHours = root.querySelector('#cb-extra-hours');
    const animator = root.querySelector('#cb-animator');
    const animatorDuration = root.querySelector('#cb-animator-duration');
    const extraPrintPacks = root.querySelector('#cb-extra-print-packs');
    const accessories = root.querySelector('#cb-accessories');
    const occasion = root.querySelector('#cb-booking-occasion');
    const bookingDate = root.querySelector('#cb-booking-date');
    const bookingDateError = root.querySelector('#cb-booking-date-error');
    const unavailableDatesSource = root.querySelector('[data-cb-unavailable-dates]');
    const otherOccasion = root.querySelector('[data-cb-other-occasion]');
    const otherOccasionInput = root.querySelector('#cb-booking-occasion-other');
    const summaryName = root.querySelector('#cb-summary-name');
    const summaryMeta = root.querySelector('#cb-summary-meta');
    const summaryFeatures = root.querySelector('#cb-summary-features');
    const summaryPrice = root.querySelector('#cb-summary-price');
    const summaryOptions = root.querySelector('#cb-summary-options');
    const estimate = root.querySelector('#cb-booking-estimate');
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style: 'currency', currency: 'EUR'});
    const count = (field) => Math.max(0, Number.parseInt(field?.value || '0', 10) || 0);
    const unavailableDates = new Set((() => {
      try {
        const configuredDates = JSON.parse(unavailableDatesSource?.textContent || '""');
        return String(configuredDates || '').split(/[\s,;]+/).filter((date) => /^\d{4}-\d{2}-\d{2}$/.test(date));
      } catch (_error) {
        return [];
      }
    })());

    const update = () => {
      const selected = plan.options[plan.selectedIndex];
      const hours = count(extraHours);
      const hostHours = animator.value === 'Oui' ? 5 + hours : 0;
      const hostCost = hostHours * 20;
      const printPacks = count(extraPrintPacks);
      const total = Number(selected.dataset.price) + hours * 25 + hostCost + printPacks * 39;
      const featureTemplate = root.querySelector(`#cb-plan-features-${selected.dataset.plan}`);
      const optionParts = [];

      summaryName.textContent = selected.dataset.name;
      summaryMeta.textContent = `${root.dataset.durationLabel} · ${selected.dataset.prints} ${root.dataset.printsLabel}`;
      summaryPrice.textContent = formatter.format(total);
      estimate.value = `${formatter.format(total)} · ${root.dataset.estimateSuffix}`;
      animatorDuration.value = `${hostHours} ${root.dataset.hourShort}`;
      summaryFeatures.replaceChildren(featureTemplate.content.cloneNode(true));

      if (hours) optionParts.push(`${hours} ${root.dataset.extraHoursLabel}`);
      if (hostHours) optionParts.push(`${root.dataset.animatorLabel} · ${hostHours} ${root.dataset.hourShort} (${formatter.format(hostCost)})`);
      if (printPacks) optionParts.push(`${printPacks * 50} ${root.dataset.extraPrintsLabel}`);
      if (accessories.value === 'Oui') optionParts.push(root.dataset.accessoriesLabel);
      summaryOptions.textContent = optionParts.join(' · ');
      summaryOptions.hidden = optionParts.length === 0;
    };

    const updateOtherOccasion = () => {
      const isOther = occasion.value === 'Autre';
      otherOccasion.hidden = !isOther;
      otherOccasionInput.disabled = !isOther;
      otherOccasionInput.required = isOther;
      if (!isOther) otherOccasionInput.value = '';
    };

    const updateDateAvailability = () => {
      const isUnavailable = bookingDate.value !== '' && unavailableDates.has(bookingDate.value);
      bookingDate.setCustomValidity(isUnavailable ? bookingDateError.textContent.trim() : '');
      bookingDateError.hidden = !isUnavailable;
    };

    const requestedPlan = new URLSearchParams(window.location.search).get('formule');
    const matchingOption = Array.from(plan.options).find((option) => option.dataset.plan === requestedPlan);
    if (matchingOption) plan.value = matchingOption.value;

    [plan, extraHours, animator, extraPrintPacks, accessories].forEach((field) => {
      field.addEventListener('input', update);
      field.addEventListener('change', update);
    });
    occasion.addEventListener('change', updateOtherOccasion);
    bookingDate.addEventListener('input', updateDateAvailability);
    bookingDate.addEventListener('change', updateDateAvailability);
    updateOtherOccasion();
    updateDateAvailability();
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
